import { GroundWaterIcon } from '../icons'

export default {
  id: 'groundwater',
  title: {
    en: 'Groundwater',
    ar: 'المياه الجوفية'
  },
  description: {
    en: `<p>Groundwater is water stored in spaces between rock particles under the surface of the Earth.</p><p>Jordan relies heavily on groundwater, which has resulted in water being drawn faster than the underground aquifers can recharge. This is known as <strong>"over abstraction"</strong> and is not a sustainable solution.</p>`,
    ar: ``
  },
  Icon: GroundWaterIcon,
  entries: [
    {
      id: 'sarhan',
      title: {
        en: 'sarhan',
        ar: 'السرحان'
      },
      safeYield: '5',
      totalExtraction: '1.5',
      balance: '3.5'
    },
    {
      id: 'yarmouk',
      title: {
        en: 'Yarmouk',
        ar: 'اليرموك'
      },
      safeYield: '40',
      totalExtraction: '55',
      balance: '-15'
    },
    {
      id: 'jordan-river-side',
      title: {
        en: 'Jordan River Side Valleys',
        ar: 'الأودية الجانبية'
      },
      safeYield: '15',
      totalExtraction: '12',
      balance: '3'
    },
    {
      id: 'jordan-river',
      title: {
        en: 'Jordan Valley',
        ar: 'وادي الأردن'
      },
      safeYield: '21',
      totalExtraction: '38',
      balance: '-17'
    },
    {
      id: 'amman-zarqa',
      title: {
        en: 'Amman/Zarqa',
        ar: 'عمان الزرقاء'
      },
      safeYield: '87',
      totalExtraction: '138',
      balance: '-51'
    },
    {
      id: 'deadsea',
      title: {
        en: 'Dead Sea',
        ar: 'البحر الميت'
      },
      safeYield: '57',
      totalExtraction: '85',
      balance: '-28'
    },
    {
      id: 'northern-araba',
      title: {
        en: 'Northern Araba Valley',
        ar: 'وادي عربة الشمالي'
      },
      safeYield: '4',
      totalExtraction: '4',
      balance: '0'
    },
    {
      id: 'southern-araba',
      title: {
        en: 'Southern Araba Valley',
        ar: 'وادي عربة الجنوبي'
      },
      safeYield: '6',
      totalExtraction: '5',
      balance: '1'
    },
    {
      id: 'jafer',
      title: {
        en: 'Jafer',
        ar: 'الجفر'
      },
      safeYield: '9',
      totalExtraction: '23',
      balance: '-14'
    },
    {
      id: 'azraq',
      title: {
        en: 'Azraq',
        ar: 'الأزرق'
      },
      safeYield: '24',
      totalExtraction: '56',
      balance: '-32'
    },
    {
      id: 'hammad',
      title: {
        en: 'Hammad',
        ar: 'الحماد'
      },
      safeYield: '24',
      totalExtraction: '56',
      balance: '-32'
    },
    {
      id: 'disi',
      title: {
        en: 'Disi',
        ar: 'الديسي'
      },
      totalExtraction: '65'
    }
  ]
}
